module.exports = __webpack_public_path__ + "img/ic_bitcointalk.e1b83eeb.svg";